var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import removeSchemaFromAsset from '../../requests/service/removeSchemaFromAsset';
/**
 *
 */
var RemoveSchemaFromAssetCommand = /** @class */ (function (_super) {
    __extends(RemoveSchemaFromAssetCommand, _super);
    function RemoveSchemaFromAssetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param organisation OrganisationModel
     * @param assetModel AssetModel
     * @param serviceAssetSchemaModel ServiceAssetSchemaModel
     * @param serviceAssetSchemaCollection ServiceAssetSchemaCollection
     * @param intl
     * @return {*}
     */
    RemoveSchemaFromAssetCommand.prototype.execute = function (organisation, assetModel, serviceAssetSchemaModel, serviceAssetSchemaCollection, intl) {
        this.intl = intl;
        this.serviceAssetSchemaModel = serviceAssetSchemaModel;
        this.assetModel = assetModel;
        this.serviceAssetSchemaCollection = serviceAssetSchemaCollection;
        var promise = removeSchemaFromAsset(serviceAssetSchemaModel, organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    RemoveSchemaFromAssetCommand.prototype.then = function (response) {
        this.serviceAssetSchemaCollection.remove(this.serviceAssetSchemaModel);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.to.asset.removed' }, { assetId: this.assetModel.id }), 'dark', true);
    };
    return RemoveSchemaFromAssetCommand;
}(Command));
export default RemoveSchemaFromAssetCommand;
